import {isNotNil} from 'ramda';

const STORAGE_GET_SEGMENT = '/get/';
const STORAGE_RESIZE_SEGMENT = '/resize/';
// Every other query param (height, fit, format, quality, …) is an image transform and is dropped.
const KEPT_STORAGE_PARAMS = ['token', 'namespace', 'filename'];

/**
 * `/resize/` URL scaled to `width` (never enlarged), else `null`. An HTTP(S) URL whose pathname
 * contains a `/get/` or `/resize/` segment is treated as a storage photo URL (same path-segment
 * convention as getGridPhotos.ts); there is no host validation.
 */
export const getResizedStoragePhotoUrl = (url: string, width: number) => {
  const photoUrl = new URL(url, window.location.href);

  if (photoUrl.protocol !== 'http:' && photoUrl.protocol !== 'https:') {
    return null;
  }

  if (
    !photoUrl.pathname.includes(STORAGE_GET_SEGMENT) &&
    !photoUrl.pathname.includes(STORAGE_RESIZE_SEGMENT)
  ) {
    return null;
  }

  const resizedParams = new URLSearchParams();
  KEPT_STORAGE_PARAMS.forEach((param) => {
    const value = photoUrl.searchParams.get(param);
    if (isNotNil(value)) {
      resizedParams.set(param, value);
    }
  });
  resizedParams.set('width', width.toString());
  resizedParams.set('withoutEnlargement', 'true');

  photoUrl.pathname = photoUrl.pathname.replace(STORAGE_GET_SEGMENT, STORAGE_RESIZE_SEGMENT);
  photoUrl.search = resizedParams.toString();

  return photoUrl.toString();
};
